/* Vela Nine — promotion countdown and real low-stock messaging.
   Both are driven by real data: the countdown by a single fixed deadline set in
   the theme editor, the stock note by the variant's actual tracked inventory.
   Nothing here invents scarcity, and the countdown never restarts. */
(function () {
  var pad = function (n) { return n < 10 ? '0' + n : String(n); };

  /* ---------- Countdown ---------- */
  function tick(promo) {
    var end = Number(promo.dataset.vnEnd) * 1000;
    var left = end - Date.now();

    if (left <= 0) {
      // A daily offer rolls to the same hour tomorrow — the same moment for
      // everybody, not a fresh 24 hours for whoever happens to be looking.
      if (promo.dataset.vnDaily === '1') {
        promo.dataset.vnEnd = String(Number(promo.dataset.vnEnd) + 86400);
        return true;
      }
      // A one-off offer is over. Remove it rather than looping back.
      promo.remove();
      return false;
    }

    var secs = Math.floor(left / 1000);
    var d = Math.floor(secs / 86400);
    var h = Math.floor((secs % 86400) / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var s = secs % 60;

    var set = function (sel, value) {
      var el = promo.querySelector(sel);
      if (el) el.textContent = value;
    };
    set('[data-vn-days]', pad(d));
    set('[data-vn-hours]', pad(h));
    set('[data-vn-mins]', pad(m));
    set('[data-vn-secs]', pad(s));

    // Final hour earns a visual nudge; before that it stays calm.
    promo.classList.toggle('is-final', left < 3600000);
    return true;
  }

  function startCountdowns() {
    document.querySelectorAll('[data-vn-promo]').forEach(function (promo) {
      if (promo.dataset.vnStarted) return;
      promo.dataset.vnStarted = '1';
      if (!tick(promo)) return;
      var id = setInterval(function () {
        if (!document.body.contains(promo) || !tick(promo)) clearInterval(id);
      }, 1000);
    });
  }

  /* ---------- Copy the discount code ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vn-copy]');
    if (!btn) return;
    var code = btn.dataset.vnCopy;
    var label = btn.querySelector('[data-vn-copy-label]');
    var done = function () {
      if (!label) return;
      var previous = label.textContent;
      label.textContent = btn.dataset.vnCopied || 'Copied';
      setTimeout(function () { label.textContent = previous; }, 2000);
    };
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(done).catch(function () {});
    }
  });

  /* ---------- Real low-stock note after adding to the bag ----------
     window.VELA_STOCK is written by the product page and only ever contains
     variants whose inventory is genuinely tracked and genuinely low. */
  var THRESHOLD = 6;

  function stockMessage(qty) {
    var word = qty === 1 ? 'one left' : 'only ' + qty + ' left';
    return 'Hurry — ' + word + ' in this size.';
  }

  function showNote(qty) {
    var hosts = [
      document.querySelector('cart-notification .cart-notification__links'),
      document.querySelector('cart-notification .cart-notification'),
      document.querySelector('cart-drawer .drawer__footer'),
      document.querySelector('cart-drawer .drawer__inner')
    ].filter(Boolean);
    if (!hosts.length) return false;

    var host = hosts[0];
    var existing = host.parentNode.querySelector('.vn-stock-note');
    if (existing) existing.remove();

    var note = document.createElement('p');
    note.className = 'vn-stock-note';
    note.setAttribute('role', 'status');
    note.textContent = stockMessage(qty);
    host.parentNode.insertBefore(note, host);
    return true;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !window.VELA_STOCK) return;

    var input = form.querySelector('[name="id"]');
    if (!input) return;

    var qty = window.VELA_STOCK[String(input.value)];
    if (!qty || qty > THRESHOLD) return;

    // Dawn renders the notification asynchronously; watch briefly for it.
    var attempts = 0;
    var poll = setInterval(function () {
      attempts += 1;
      if (showNote(qty) || attempts > 20) clearInterval(poll);
    }, 150);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCountdowns);
  } else {
    startCountdowns();
  }
  // The theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', startCountdowns);
})();
